<template>
  <div>
    <div class="row justify-content-center align-items-center">
      <div class="col">
        <label>شروع</label>
        <input type="time" pattern="\d+" v-model="workTimeItem[0]" class="form-control">
      </div>
      <div class="col">
        <label>پایان</label>
        <input type="time" v-model="workTimeItem[1]" class="form-control">
      </div>

      <div class="col">
        <b-btn @click="removeDayItemWorkTime()">
          حذف
          <b-icon-x class="h4"/>
        </b-btn>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: "HourWorkTimeItem",
  props: {
    reservation: {},
    workTimeItem: {},
    dayIndex: {},
    dayItemIndex: {},
    workTimes: {},
  },
  methods: {
    removeDayItemWorkTime() {
      const dayIndex = this.dayIndex
      const dayItemIndex = this.dayItemIndex
      this.workTimes[dayIndex].splice(dayItemIndex, 1)
      this.$forceUpdate()
      this.$emit('remove', true)
    }
  }
}
</script>

<style scoped>

</style>